import { ActionType, SearchState } from "../../schemas/Search/Search.schema";
import * as Constants from "../../utils/constants";
import produce from "immer";

export const initalSearchState: SearchState = {
  loads: {
    searchLoads: [],
    totalRecords: 0,
  },
  params: {},
  allLoads: [],
  showBuyLoadAPIError: false,
  countryCodes: [],
  stofLoads: {},
  offset: {
    destinationDateDefaultOffset: "",
    originDateDefaultOffset: ""
  }
};

export default (state = initalSearchState, action: ActionType) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Constants.STOF_DATA:
        draft.stofLoads = action.payload;
        break;
      case Constants.SEARCH_DATA:
        draft.params = action.payload;
        break;
      case "loadSearchData":
        const payload = action.payload && (action.payload as any);
        const isPagination = payload.isPagination;
        draft.loads = {
          searchLoads: isPagination
            ? draft.loads.searchLoads.concat(
              (getSearchLoads(payload))
            )
            : (getSearchLoads(payload)),
          totalRecords:
          (getTotalLoads(payload)),
        };
        break;
      case Constants.SAVE_ALL_SEARCH_DATA:
        const payLoad = action.payload && (action.payload as any);
        const load = {
          searchLoads:(getSearchLoads(payLoad)),
          totalRecords:
            (getTotalLoads(payLoad)),
        };
        draft.allLoads = [...draft.allLoads, load];
        break;
      case Constants.CLEAR_SEARCH_RESULTS:
        draft.loads = action.payload;
        break;
      case Constants.REMOVE_SEARCH_RESULTS:
        const removedLoad = actionPayloadValidation(action);
        draft.loads.searchLoads = draft.loads.searchLoads.filter(
          (details: any) => details.loadId !== removedLoad
        );
        draft.loads.totalRecords = draft.loads.totalRecords ? (draft.loads.totalRecords - 1) : 0;
        break;
      case Constants.SHOW_BUYLOAD_API_ERROR:
        draft.showBuyLoadAPIError = action.payload && (action.payload as any);
        break;
      case Constants.LOAD_STATE_COUNTRY_CODES: {
        const { response } = actionPayloadValidation(action);
        draft.countryCodes = response.countries;
        draft.offset.originDateDefaultOffset = response.originDateDefaultOffset;
        draft.offset.destinationDateDefaultOffset = response.destinationDateDefaultOffset;
        break;
      }
      case Constants.UPDATE_DATE_OFFSET: {
        draft.offset = action.payload && (action.payload as any);
        break;
      }
    }
  });
function getTotalLoads(payLoad: any) {
  return payLoad && payLoad.data && payLoad.data.totalRecords||0;
}

function getSearchLoads(payLoad: any) {
  return payLoad && payLoad.data && payLoad.data.searchLoads||[];
}

function actionPayloadValidation(action: ActionType): { response: any; } {
  return action.payload && (action.payload as any);
}

